/**
 * Hook to determine if payments UI should be shown.
 * - REACT_APP_PAYMENTS_ENABLED=false → never show
 * - REACT_APP_PAYMENTS_ADMIN_ONLY=true → only show for admins (for live testing)
 * - Otherwise → show for everyone
 */
import { useState, useEffect } from 'react';
import { useUserProfile } from '../contexts/UserProfileContext';
import { useAuth } from './useAuth';

export function usePaymentsVisibility(): boolean {
  const { isSignedIn, user } = useAuth();
  const { userProfile } = useUserProfile();
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);

  const paymentsEnabled = process.env.REACT_APP_PAYMENTS_ENABLED !== 'false';
  const adminOnlyMode = process.env.REACT_APP_PAYMENTS_ADMIN_ONLY === 'true';

  useEffect(() => {
    if (userProfile && userProfile.id === user?.userId) {
      setIsAdmin(userProfile.is_admin === true);
    } else if (!isSignedIn || !user) {
      setIsAdmin(false);
    }
  }, [userProfile?.id, userProfile?.is_admin, user?.userId, isSignedIn]);

  if (!paymentsEnabled) return false;
  if (!adminOnlyMode) return true;
  return isAdmin === true;
}
